// extracted by mini-css-extract-plugin
module.exports =  {"root":"iaLoc0U5pJgkPAPaXyMY"};